module.exports = __webpack_public_path__ + "static/media/firefox.31a489a7.png";